var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBurgerClose = function SvgIconBurgerClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.53 7.53 17.06 16l8.47 8.47-1.06 1.06L16 17.06l-8.47 8.47-1.06-1.06L14.94 16 6.47 7.53l1.06-1.06L16 14.94l8.47-8.47z"
  })));
};
export default SvgIconBurgerClose;